import Service from "../../../service/api.js";
import store from '../../store'

const LearningProfileModule = {
    state: {
        userProfile: '',
        userCourse: '',
        acessToken: ""
    },

    mutations: {
        authUser(state, userData) {
            state.userData = userData;
            state.isSignin = true
            state.acessToken = res.data.acessToken
        },
        commitUserData(state, res) {
            console.log('commitUserData', res)
            state.userProfile = res.userProfile //v3 fix 
            state.userCourse = res.userCourse //v3 fix
        },
    },

    actions: {
        fetchUserDataByToken({ commit }) {
            Service.fetchUserDataAPI().then((res) => {
                commit('commitUserData', res.data.data)
                commit('necessary/setCourseOverview', res.data.data.userCourse) //v3 fix
            }).catch(err => console.log(err))
        },
        addFavoutiteCourse({ commit }, payload) {
            Service.addFavouriteCourse(payload).then((res) => {
                commit('commitUserData', res.data)
                store.dispatch('auth/fetchCourseEducation')
            }).catch((err) => {
                console.log(err)
            })
        },
        deleteFavoutiteCourse({ commit }, payload) {
            Service.deleteFavouriteCourse(payload).then((res) => {
                commit('commitUserData', res.data)
                store.dispatch('auth/fetchCourseEducation')
            }).catch((err) => {
                //console.log(err)
                alert("Error:Could not remove this favourite course!")
            })
        }
    },
    getters: {
        userProfileGetter(state) {
            return state.userProfile;
        },
        userCourseGetter(state) {
            return state.userCourse;
        }
    },
};

export default LearningProfileModule;